import { ZollerFocus } from './zoller-focus';
import { ZollerMode } from './zoller-mode';

export class ToolHolderStep {
  constructor(
    public hash?: string,
    public step?: number,
    public ces?: number,
    public zollerFocus?: ZollerFocus,
    public zollerMode?: ZollerMode,
    public rangeWidth?: number,
    public rangeHeight?: number,
    public longitude?: number,
    public zUpperTol?: number,
    public zLowerTol?: number,
    public x?: number,
    public xUpperTol?: number,
    public xLowerTol?: number,
    public searchRunZ?: boolean,
    public searchRunX?: boolean,
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-holder-step.ts